import pickBy from 'lodash/pickBy';

import { post } from './base';
import { isNotEmpty } from '../lib/helpers';

const InsightsAPI = {
  associate({
    baseURL,
    clientID,
    analyticsID,
    apiKey,
    parkwhizID = null,
    emailSubscriberID = null,
    platform = 'desktop_web',
    userAgent = null,
    browser = null,
    utmData = [],
    location = [],
    referringURL = null,
    affiliateID = null,
  }) {
    let url;
    if (typeof window === 'undefined') {
      url = `https:${baseURL}/associate/`;
    } else {
      url = `${baseURL}/associate/`;
    }

    const data = pickBy({
      client_id: clientID,
      analytics_id: analyticsID,
      parkwhiz_id: parkwhizID,
      eid: emailSubscriberID,
      platform,
      browser,
      user_agent: userAgent,
      utm_data: utmData,
      location,
      referring_url: referringURL,
      affiliate_id: affiliateID,
    }, isNotEmpty);

    const headers = { 'api-key': apiKey };

    return post({
      url,
      data,
      headers,
    });
  },
  trackAnalyticsEvent({
    baseURL,
    apiKey,
    events,
  }) {
    let url;
    if (typeof window === 'undefined') {
      url = `https:${baseURL}/events/`;
    } else {
      url = `${baseURL}/events/`;
    }
    const data = events.map(({
      timestamp,
      clientID,
      analyticsID,
      name,
      type,
      position,
      properties,
      eventName,
      eventID,
      pageName,
      pageType,
      pageUUID,
    }) => (pickBy({
      timestamp,
      name,
      type,
      position,
      properties,
      client_id: clientID,
      analytics_id: analyticsID,
      event_name: eventName,
      event_id: eventID,
      page_name: pageName,
      page_type: pageType,
      page_uuid: pageUUID,
    }, isNotEmpty)));

    const headers = { 'api-key': apiKey };

    return post({
      url,
      data,
      headers,
    });
  },
  participate({
    baseURL,
    apiKey,
    experiment,
    forceOption,
    platform,
    browser,
    association,
  }) {
    let url;
    if (typeof window === 'undefined') {
      url = `https:${baseURL}/participate/`;
    } else {
      url = `${baseURL}/participate/`;
    }

    const associationData = pickBy({
      client_id: association.clientID,
      analytics_id: association.analyticsID,
      parkwhiz_id: association.parkwhizID,
    }, isNotEmpty);

    const data = pickBy({
      experiment,
      platform,
      browser,
      force_option: forceOption,
      association: associationData,
    }, isNotEmpty);

    const headers = { 'api-key': apiKey };

    return post({
      url,
      data,
      headers,
    });
  },
};

export default InsightsAPI;
